import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {NotAuthGuard} from "@cybfed/core/guards/not-auth.guard";
import {AdminComponent} from "@white-label/layout/admin/admin.component";

export const streamerRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('../../pages/landing/landing.component').then(module => module.LandingComponent)
  },
  {
    path: 'p/:slug',
    loadComponent: () => import('../../pages/white-label-pages/white-label-pages.component').then(module => module.WhiteLabelPagesComponent)
  },
  {
    path: 'admin',
    component: AdminComponent,
    loadChildren: () => import('../../layout/admin/admin-routing.module').then(module => module.AdminRoutingModule)
  },
  // {
  //   path: 'news',
  //   loadComponent: () => import('../../pages/news/news.component').then(module => module.NewsComponent)
  // },
  // {
  //   path: 'market',
  //   loadChildren: () => import('../../pages/market/market-routing.module').then(module => module.MarketRoutingModule)
  // },
  // {
  //   path: 'marketplace',
  //   loadChildren: () => import('@cybfed/new-ui/pages/functional/store/store-routing.module').then(module => module.StoreRoutingModule)
  // },
  {
    path: 'portfolio',
    loadComponent: () => import('../../pages/portfolio/portfolio.component').then(module => module.PortfolioComponent)
  },
  // {
  //   path: 'events',
  //   loadComponent: () => import('../../pages/challenges/challenges.component').then(module => module.ChallengesComponent)
  // },
  {
    path: 'me',
    loadChildren: () => import('@cybfed/old-ui/pages/my-profile/my-profile-routing.module').then(module => module.MyProfileRoutingModule)
  },
  // {
  //   path: 'about',
  //   loadComponent: () => import('@cybfed/new-ui/pages/landings/about-us/about-us-page.component').then(module => module.AboutUsPageComponent)
  // },
  // {
  //   path: 'privacy',
  //   loadComponent: () => import('@cybfed/new-ui/pages/landings/privacy/privacy.component').then(module => module.PrivacyComponent)
  // },
  // {
  //   path: 'terms',
  //   loadComponent: () => import('@cybfed/new-ui/pages/landings/terms/terms.component').then(module => module.TermsComponent)
  // },
  // {
  //   path: 'faq',
  //   loadComponent: () => import('@cybfed/new-ui/pages/landings/faq/faq.component').then(module => module.FaqComponent)
  // },
  {
    path: 'auth',
    canActivate: [NotAuthGuard],
    loadChildren: () => import('@cybfed/old-ui/pages/authentication/authentication-routing.module').then(module => module.AuthenticationRoutingModule)
  },
  {
    path: 'ai-assistant',
    loadComponent: () => import('../../pages/admin-mode/ai-assistant/ai-assistant.component').then(module => module.AiAssistantComponent)
  },
];

@NgModule({
  imports: [RouterModule.forChild(streamerRoutes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
